var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MiniCard", {
    attrs: {
      colorCode: _vm.$config.account.colorCode,
      badge: _vm.badge,
      noIcon: _vm.noIcon,
      title: _vm._f("pgettext")("Account", "Account"),
      icon: _vm.$config.account.icon,
      text: _vm.item.name,
      linkTo: {
        name: "app.account",
        params: { id: _vm.item.id }
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }